import { render, staticRenderFns } from "./AffiliationDocumentUpdate.vue?vue&type=template&id=585aac1f"
import script from "./AffiliationDocumentUpdate.vue?vue&type=script&lang=js"
export * from "./AffiliationDocumentUpdate.vue?vue&type=script&lang=js"
import style0 from "./AffiliationDocumentUpdate.vue?vue&type=style&index=0&id=585aac1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports